import { createContext, useContext } from 'react'
import lang from './lang.json'

/**
 * The reference game's own dictionary, eight languages in its order (index 4 = ไทย, its
 * default). Some languages lack a few keys the English one has; those fall back to English
 * rather than rendering a key name.
 */

export const LANGUAGES: string[] = lang.languages
const DICTS = lang.dict as Record<string, string>[]
export const DEFAULT_LANG = 4

export type Translate = (key: string) => string

export function translator(langId: number): Translate {
  const d = DICTS[langId] ?? DICTS[DEFAULT_LANG]!
  const en = DICTS[0]!
  return (key) => d[key] ?? en[key] ?? key
}

export const LocaleContext = createContext<{ langId: number; t: Translate }>({
  langId: DEFAULT_LANG,
  t: translator(DEFAULT_LANG),
})

export function useT(): Translate {
  return useContext(LocaleContext).t
}

const LANG_KEY = 'keno_lang'

export function savedLang(): number {
  try {
    const n = Number(window.localStorage.getItem(LANG_KEY))
    return Number.isInteger(n) && n >= 0 && n < LANGUAGES.length && window.localStorage.getItem(LANG_KEY) !== null ? n : DEFAULT_LANG
  } catch {
    return DEFAULT_LANG
  }
}

export function saveLang(n: number): void {
  try { window.localStorage.setItem(LANG_KEY, String(n)) } catch { /* private mode */ }
}

/** `?l=` on a popup window (the reference passes the language that way). */
export function langFromQuery(): number {
  const n = Number(new URLSearchParams(window.location.search).get('l'))
  return Number.isInteger(n) && n >= 0 && n < LANGUAGES.length ? n : savedLang()
}
